"use strict";
/* This is a generated file, do not edit */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphEdge = void 0;
var Param_1 = require("../../rmf_building_map_msgs/msg/Param");
var GraphEdge = /** @class */ (function () {
    function GraphEdge(fields) {
        if (fields === void 0) { fields = {}; }
        this.v1_idx = fields.v1_idx || 0;
        this.v2_idx = fields.v2_idx || 0;
        this.params = fields.params || [];
        this.edge_type = fields.edge_type || 0;
    }
    GraphEdge.validate = function (obj) {
        var e_1, _a;
        if (typeof obj['v1_idx'] !== 'number') {
            throw new Error('expected "v1_idx" to be "number"');
        }
        if (typeof obj['v2_idx'] !== 'number') {
            throw new Error('expected "v2_idx" to be "number"');
        }
        if (!Array.isArray(obj['params'])) {
            throw new Error('expected "params" to be an array');
        }
        try {
            for (var _b = __values(obj['params'].entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), i = _d[0], v = _d[1];
                try {
                    Param_1.Param.validate(v);
                }
                catch (e) {
                    throw new Error("in index " + i + " of \"params\":\n  " + e.message);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (typeof obj['edge_type'] !== 'number') {
            throw new Error('expected "edge_type" to be "number"');
        }
    };
    GraphEdge.FullTypeName = 'rmf_building_map_msgs/msg/GraphEdge';
    GraphEdge.EDGE_TYPE_BIDIRECTIONAL = 0;
    GraphEdge.EDGE_TYPE_UNIDIRECTIONAL = 1;
    return GraphEdge;
}());
exports.GraphEdge = GraphEdge;
/*
uint32 v1_idx
uint32 v2_idx
Param[] params

# when edge_type is UNIDIRECTIONAL, it means v1 -> v2
# when edge_type is BIDIRECTIONAL, it means v1 <-> v2
uint8 edge_type
uint8 EDGE_TYPE_BIDIRECTIONAL=0
uint8 EDGE_TYPE_UNIDIRECTIONAL=1

*/
